import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocationDot, faBacon } from "@fortawesome/free-solid-svg-icons";

const chacinados = [
  {
    nombre: "Chacinados Caseros “El Gringo”",
    link: "https://maps.app.goo.gl/PAB1zWRTMF4KWx6eA",
    direccion: (
      <>
        Leandro N. Alem 67.<br />
        3532-467549
      </>
    ),
  },
  {
    nombre: "Salames del Campo",
    link: "https://maps.app.goo.gl/wVHbXnHciA3MtpiZ6",
    direccion: (
      <>
        Rivadavia 652.<br />
        3532-678894
      </>
    ),
  },
  {
    nombre: "Chacinados Don Alberto",
    link: "https://maps.app.goo.gl/jgAEyKm7tee7QUCZ8",
    direccion: (
      <>
        Italia 233.<br />
        3532-466857
      </>
    ),
  },
  {
    nombre: "Carnicería TC Todo Cerdo",
    link: "https://maps.app.goo.gl/Tjsje6CigkmFQFhx8",
    direccion: (
      <>
        Av. Olmos 323.<br />
        3532-405555
      </>
    ),
  },
  {
    nombre: "Carnicería El Tio Mario",
    link: "https://maps.app.goo.gl/Tc3yzQiBYGZMgkRWA",
    direccion: (
      <>
        Italia 177.<br />
        03532 - 15467958
      </>
    ),
  },
];

const Chacinados = () => (
  <div className="content-tab">
    <div className="row">
      <div className="col-12 col-md-6">
        <h5>
          <FontAwesomeIcon icon={faBacon} style={{ color: "#c0392b", marginRight: 8 }} />
          Chacinados y Carnicerías
        </h5>
        <ul className="lista-referencias">
          {chacinados.map((item, i) => (
            <li key={i}>
              <FontAwesomeIcon icon={faMapLocationDot} style={{ color: "#2980b9", marginRight: 8 }} />
              <a href={item.link} target="_blank" rel="noopener noreferrer">
                {item.nombre}
              </a>
              <div className="ms-2 me-auto">{item.direccion}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

export default Chacinados;